export function pluralize(count, singular, plural) {
  const finalPlural = plural ?? `${singular}s`;
  return `${count} ${count === 1 ? singular : finalPlural}`;
}